import { ApolloQueryResult, FetchResult, useMutation, useQuery } from "@apollo/client"
import { useSelectedLinkContext } from "contexts";
import { CreateVideoCallOutput, GetAvailableVideoCallsOutput, VideoCallOutput } from "graphql/communicate/videocall/VideoCall.types"
import { CREATE_VIDEO_CALL_MUTATION } from "graphql/communicate/videocall/VideoCallMutations";
import { GET_VIDEO_CALLS_QUERY } from "graphql/communicate/videocall/VideoCallQueries"

type UseVideoCallsOutput = {
  createVideoCall: (emails: string[]) => Promise<FetchResult<CreateVideoCallOutput>>;
  data: VideoCallOutput[];
  refetch: () => Promise<ApolloQueryResult<GetAvailableVideoCallsOutput>>;
}

const useVideoCalls = (): UseVideoCallsOutput => {
  const { selectedLink } = useSelectedLinkContext();

  const { data, refetch } = useQuery<GetAvailableVideoCallsOutput>(
    GET_VIDEO_CALLS_QUERY,
    {
      variables: {
        getAvailableVideoCallsInput: {
          channel: selectedLink?.channelKey,
        },
      },
    },
  )

  const [createVideoCallGQL] = useMutation<CreateVideoCallOutput>(
    CREATE_VIDEO_CALL_MUTATION,
  );

  const createVideoCall = (emails: string[]): Promise<FetchResult<CreateVideoCallOutput>> => {
    return createVideoCallGQL({
      variables: {
        createVideoCallInput: {
          channel: selectedLink.channelKey,
          participantEmails: emails.filter(email => !!email),
        },
      },
    });
  }

  return { data: data?.getAvailableVideoCalls?.videoCalls, refetch, createVideoCall }
}

export default useVideoCalls;